import '@sass/airline/airline.scss';
import { documentReady, gebi, getUrlVars, setUrlParameter } from '@utils/toolbox';
import { SearchBox } from '@module/SearchBox/SearchBox';
import '@module/Rating/Rating.js';
import '@module/LinkBox/LinkBox.js';


documentReady(function () {
	window.searchBox = new SearchBox(
		{
			id: 'abSearchBox',
			calendarRender: gebi('dateselector'),
			config: null,
			callbacks:
			{
				onPreviewReceived: function (instance, previewGroup) {
					if (previewGroup?.flights?.length) {
						instance.cancelSearch();
						location.href = instance.showresultURL;
					}
				},
				onSearchComplete: (instance) => {
					const urlVars = getUrlVars();

					if (urlVars?.filter) {
						instance.showresultURL = setUrlParameter(instance.showresultURL, 'filter', urlVars.filter);
					}

					location.href = instance.showresultURL;
				}
			}
		});
});
